import { render } from "./ProductsRenderer.vue?vue&type=template&id=2ed3ff20&scoped=true"
const script = {}

import "./ProductsRenderer.vue?vue&type=style&index=0&id=2ed3ff20&lang=scss&scoped=true"
import "./ProductsRenderer.vue?vue&type=style&index=1&id=2ed3ff20&lang=scss"

import exportComponent from "/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ed3ff20"]])

export default __exports__